'use client';

import { CHUNK_ERROR_PATTERNS } from '@/constants/safe-guard';
import { useEffect } from 'react';

function isChunkError(error: Error): boolean {
    if (error.name === 'ChunkLoadError') return true;
    return CHUNK_ERROR_PATTERNS.some((re) => re.test(error.message ?? ''));
}

export default function Error({
    error,
}: {
    error: Error & { digest?: string };
    reset?: () => void;
}): React.ReactElement {
    const chunk = isChunkError(error);
    useEffect(() => {
        if (!chunk) return;
        const target =
            sessionStorage.getItem('vg-pending-url') ?? window.location.href;
        sessionStorage.removeItem('vg-pending-url');
        window.location.replace(target);
    }, [error, chunk]);

    if (!chunk) {
        console.log('[ErrorGuard] non-chunk error, re-throwing');
        throw error;
    }

    return <></>;
}
